<template>
	<div>
		<headerBox :current="1"></headerBox>
		<bannerBox ref="bannerChild"></bannerBox>
		<div class="content_box">
			<left-tabs ref="tabsChild" :bgColor='1' @change="getMenu" :menu="menuList"></left-tabs>
			<div class="right_box" :style="{width:menuList.length>0?'75%':'100%'}" v-if="infoList.length>0">
				<div v-for="(it,i) in infoList" :key="i" @click="goDetail(it)">
					<img style="width: 25%;" v-if="it.thumb" :src="it.thumb" />
					<div :style="{width: it.thumb?'70%':'100%'}">
						<div class="title single">{{it.title}}</div>
						<div class="time">{{it.date}}</div>
						<div class="article">
							{{it.description}}
						</div>
					</div>
				</div>
				<Page v-if="infoList.length!=0" class="common_page_box" @on-change="changePage" :total="total"
					:current="params.pageNo" :page-size="params.pageSize" show-total></Page>
			</div>
			<div v-if="infoList.length==0" class="common_excel_no_more">暂无内容~</div>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
	</div>
</template>

<script>
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import leftTabs from '@/components/left_tabs.vue'
	import {
		getArticle
	} from '@/api/home/index'
	export default {
		name: 'home',
		components: {
			bannerBox,
			headerBox,
			footerBox,
			leftTabs
		},
		data() {
			return {
				locationList: [],
				infoList: [],
				total: 0,
				params: {
					pageNo: 1,
					pageSize: 6
				},
				catid: '',
				menuList: [],
				current: 0
			}

		},
		mounted() {
			this.catid = this.$route.query.catid;
			if (this.$route.query.catid != 306 && this.$route.query.catid != 305) {
				this.menuList = [{
						title: '行业要闻',
						catid: 6
					},
					{
						title: '协会动态',
						catid: 91
					},
					{
						title: '通知公告',
						catid: 10
					},
					// {
					// 	title: '招采信息',
					// 	catid: 301,
					// }
				]
				let index = this.menuList.findIndex(v => v.title == decodeURIComponent(this.$route.query.name))
				this.setLocation(index);
			}else{
				this.setLocation();
			}
			this.getArticle();
		},
		methods: {
			/* ====================数据请求部分========================== */
			getArticle() {
				let catid = '';
				if (this.$route.query.catid == 306) {
					catid = 306;
				} else if (this.$route.query.catid == 305) {
					catid = 305;
				} else {
					catid = this.menuList[this.current].catid;
				}
				getArticle({
					catid: catid,
					...this.params
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.infoList = res.result.records;
						this.total = res.result.total;
					} else {
						this.infoList = [];
					}
				})
			},
			/* ====================页面交互部分========================== */
			getMenu(e) {
				this.setLocation();
				this.getArticle()
			},
			changePage(e) {
				this.params.pageNo = e;
				this.getArticle()
			},
			goDetail(it) {
				this.$router.push({
					name: 'news_detail',
					query: {
						id: it.id,
					},
					params: {
						locationList: encodeURIComponent(JSON.stringify(this.locationList))
					}
				});
			},
			setLocation(index) {
				let current = index ? index : this.$refs["tabsChild"].current;
				this.current = current;
				let locationList = [];
				if (this.$route.query.catid == 306) {
					locationList = ['首页', '会员风采'];
				}else if(this.$route.query.catid == 305){
					locationList = ['首页', '违法违规信息'];
				} else {
					locationList = ['行业动态', this.menuList[current].title];
				}
				this.locationList = locationList;
				this.$refs["tabsChild"].current = current;
				this.$refs["bannerChild"].locationList = locationList;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.content_box {
		margin: 80px 100px;
		display: flex;
		min-width: 1100px;

		.right_box {
			width: 75%;

			>div {
				border-bottom: 1px solid #eee;
				padding: 10px;
				padding-bottom: 30px;
				margin-bottom: 30px;
				cursor: pointer;
				transition: all 0.2s ease-in;
				-webkit-transition: all 0.2s ease-in;
				-moz-transition: all 0.2s ease-in;
				-o-transition: all 0.2s ease-in;
				display: flex;

				img {
					width: 250px;
					height: 180px;
					margin-right: 30px;
				}

				.title {
					font-size: 20px;
					color: #000000;
					text-align: left;
				}

				.time {
					color: #575B66;
					font-size: 15px;
					padding: 10px 0;
				}

				.article {
					color: #9E9E9E;
					font-size: 13px;
				}
			}

			>div:hover {
				// background-color: #eee;
				// padding: 15px 10px;
				box-shadow: 5px 5px 20px #9E9E9E;
			}
		}
	}
</style>
